import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getPlans } from '@queries'

const usePlansQuery = () => {
  const { projectId } = useParams()

  return useQuery<Plan[]>({
    queryKey: getPlans.getKey(projectId as string),
    queryFn: () => getPlans.request(projectId as string),
  })
}

export default usePlansQuery
